import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";

import L from "leaflet";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const MapComponent = () => {
  return (
    <MapContainer
      center={[0, 20]}
      zoom={1}
      style={{ height: "500px", width: "100%" }}
    >
      <TileLayer
        attribution="&copy; OpenStreetMap contributors"
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      <Marker position={[20.5937, 78.9629]}>
        <Popup> 
<strong>DREBCON Global Services Private Limited </strong> <br />
 PN-52B, Spring Valley, Block-1, <br />
 Kondapur, K.V.Rangareddy-500084,<br /> Telangana, India

        </Popup>
      </Marker>

      <Marker position={[23.4241, 53.8478]}>
        <Popup><strong>DREBCON </strong><br />
        3860, Prince Muhammed Bin Abdul Aziz Br. Rd,<br />
         Faisaliyyah Dist, Jeddah 23441 - 6350 <br />
         Kingdom of Saudi Arabia.
        
        
        </Popup>
      </Marker>

      <Marker position={[37.0902, -95.7129]}>
        <Popup>
            <strong>DREBCON INC</strong><br />
5900 Balcones DR, STE 15395<br />
Austin, TX 78731</Popup>
      </Marker>
    </MapContainer>
  );
};

export default MapComponent;